import template from 'lodash/template';

export const interpolate = (sourceString, dataObject) => {
  /**
   * Options for the lodash template used to allow interpolations
   */
  const templateOpts = {
    interpolate: /{{([\s\S]+?)}}/g, //interpolate content using i18next style markers `{{}}`
    evaluate: null, // prevent any js evaluation
    escape: null, // disable any escaping (our RichContent component will do this)
  };

  return template(sourceString, templateOpts)(dataObject);
};
